<template>
  <div style="height:100%" class="Parameter">
    <div class="manage">
      <div class="content">
        <div class="operation">
          <el-button type="primary" :round="false" size="small" icon="el-icon-plus" @click="add">
            <span>添加轮播图</span>
          </el-button>
        </div>
        <div class="rankSetingList">
          <template>
            <el-table :border="true" :data="tableData" style="width: 100%">
              <el-table-column prop="sort" label="排序" width="100px"></el-table-column>
              <el-table-column prop="cate_info[0].name" label="分类" width="240"></el-table-column>
              <el-table-column label="图片" width="240">
                <template slot-scope="scope">
                  <img v-for="(item, index) in scope.row.banner_url" :key="index" :src="item" alt="" style="height: 50px; margin-right: 20px">
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="Otherpage">
          <div class="changePage">
            <div @click="upPage" class="btnColor">
              <span>上一页</span>
            </div>
            <div>
              <span>{{ page }}</span>
            </div>
            <div @click="downPage" class="btnColor">
              <span>下一页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加排行榜轮播图 -->
    <el-dialog title="添加排行榜轮播图" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="分类" :label-width="formLabelWidth">
          <el-select v-model="form.cate_ids" placeholder="请选择对应分类" size="small" :disabled="chooseStatus">
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加轮播图" :label-width="formLabelWidth">
          <el-upload
            ref="upload"
            list-type="picture-card"
            action="#"
            :http-request="(file)=> { return productUploadImg(file) }"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileListData"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <p style="margin-top:10px;">
            尺寸建议750*750（正方形模式）或750*1000（长图模式）像素以上，大小2M以下，最多10张（可拖拽图片调整显示顺序）
          </p>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-table :data="selectedAttr" border v-if="selectedAttr.length > 0">
            <el-table-column property="name" label="轮播图名称" width=250></el-table-column>
            <!-- <el-table-column label="轮播图" width="200">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.SpecValue" :key="index">{{ item.value }} | </span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="deleteAttr(scope.$index, scope.row)" type="primary">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="setJson">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加排行榜轮播图 -->
  </div>
</template>

<script>
import { rankSetingList, addImage, rankSetingdel, rankSetingadd, rankSetingdetails, rankSetingedit, getCateApi } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {},
  data() {
    return {
      chooseStatus: false,
      jude: 0,
      chosepictireid:[], //已上传图片id数组暂存
      productfileListData:[],//上传文件列表
      fileListData:[], //filelist列表
      fakefileList: [], //假的filelist列表
      // 上传商品图片
      dialogImageUrl: "",
      dialogVisible: false,
      checkList: [],
      cateList: [],
      state: 0,
      attrpage: "1",
      idx: 1,
      value: "",
      input: "",
      page: "1",
      tableData: [],
      gridData: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        banner: "",
        sort: "",
        cate_ids: "", 
        
      },
      formLabelWidth: "120px",
      selectedAttr: [],
      type_id: "",
      type_name: "",
      type_sort: "",
      type_value: "",
      id: ""
    };
  },
  methods: {
    // 商品图片
    handleRemove(file) {
      //  图片删除同步更改列表
      var replaceArr = this.fakefileList;
      for(var i= 0; i < replaceArr.length; i++){
        if(file.uid == replaceArr[i].uid){
          replaceArr.splice(i,1);
          this.chosepictireid.splice(i,1);
          this.form.banner = this.chosepictireid.join(',');
          console.log(this.form.banner,"dffffffff");
          break;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传商品图片
    productUploadImg(file){
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        console.log("上传回调",res);
        var data = res.data;
        if(res.code == 200){
          this.chosepictireid.push(res.data.id);
          this.form.banner = this.chosepictireid.join(',');
          var list = {};
          var index = 0;
          list.name = res.data.key;
          list.url = res.data.url;
          // 图片列表
          this.fakefileList.push(list);
        }else{
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.form.name = "";
      this.selectedAttr = [];
    },
    handleEdit(index, row) {
      // 请求轮播图具体内容
      this.jude = 1;
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: row.id
      };
      this.form = {};
      this.fileListData = [];
      this.fakefileList = [];
      this.chosepictireid = "";
      rankSetingdetails(data).then(res => {
        console.log(res);
        if(res.code == 200){
          this.form = res.data;
          console.log("详情数据", this.form);
          // this.fileListData = this.form.banner_url;//图片列表
          // this.fakefileList = this.form.banner_url;
          var imgdata = this.form.banner_url;
          imgdata.forEach(item => {
            let obj = {}
            obj.url = item;
            this.fileListData.push(obj);
            this.fakefileList.push(obj);
          })
          console.log("图片数据", this.fileListData);
          this.chosepictireid = this.form.banner.split(",");
          this.dialogFormVisible = true;
          this.form.cate_ids = this.form.cate_ids * 1;
          this.chooseStatus = true;
        }else{
          this.$message(res.msg);
        }
      });
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: row.id
      };
      rankSetingdel(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getrankSetingList();
      });
    },
    // 轮播图列表
    getrankSetingList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      rankSetingList(data).then(res => {
        console.log("分类列表",res);
        this.tableData = res.data.result;
      });
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getrankSetingList();
      } else {
        this.getrankSetingList();
      }
    },
    downPage() {
      // 下
      this.page++;
      console.log(this.page);
      this.getrankSetingList();
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message("请添加新品牌");
        this.page--;
        this.getrankSetingList();
      }
    },
    
    select(index, row) {
      // 选择轮播图
      console.log(index, row);
      this.selectedAttr.push(row);
      this.dialogTableVisible = false;
    },
    deleteAttr(index, row) {
      // 删除选中的数据
      this.selectedAttr.splice(index, 1);
    },
    setJson() {
      console.log("确定添加", this.form);
      // 确定添加排行榜轮播图
      if (this.form.cate_ids == "" || this.fakefileList.length == 0) {
        this.$message({
          message: "请配置好数据",
          type: "warning"
        });
      } else {
        //
        let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: this.merch_id,
          banner: this.form.banner,
          sort: this.form.sort,
          cate_ids: this.form.cate_ids,
        };
        if ( this.jude == 0 ) {
          rankSetingadd(data).then(res => {
            console.log(res);
            this.$message({
              message: res.msg,
              type: "success"
            });
            
          });
        } else {
          data.id = this.form.id;
          rankSetingedit(data).then(res => {
            console.log(res);
            this.$message({
              message: res.msg,
              type: "success"
            });
          });
        }
        this.dialogFormVisible = false;
        this.getrankSetingList();
        this.form.name = "";
        this.selectedAttr = [];
      }
    },
    // 分类数据
    getCate(){
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      getCateApi(data).then(res => {
        console.log(res);
        if(res.code == 1){
          this.cateList = res.data;
        }else{
          this.$message(res.msg);
        }
      })
    },
    // 添加click
    add(){
      this.dialogFormVisible = true,
      this.jude = 0;
    }
  },
  mounted() {
    this.getrankSetingList();
    this.getCate();
  }
};
</script>

<style lang="scss" scoped>
el-table{
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
    }
    .rankSetingList {
      height: 100%;
      margin-top: 20px;
    }
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      left: 30px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}

.attrChangePage {
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .num {
    width: 30px;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
  }
}
</style>

<style lang="scss">
.Parameter {
  .manage {
    .cell {
      text-align: left;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
